const ADMIN = "ADMIN";
const MECHANIC = "MECHANIC";
const MANAGER = "ADMIN, MECHANIC";

export {
    ADMIN,
    MECHANIC,
    MANAGER
}
